import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { EditorCollapsable } from "@circle-react-shared/BuilderUI/Editor/EditorCollapsable";
import { BoxModelInput } from "@circle-react-shared/BuilderUI/Editor/fields/BoxModelField";
import { ButtonTypePicker } from "@circle-react-shared/BuilderUI/Editor/fields/ButtonTypePicker";
import { useIsPropertiesPanelRevampEnabled } from "@circle-react-shared/BuilderUI/Hooks/useIsPropertiesPanelRevamp";
import { Background } from "./Background";
import { Borders } from "./Borders";
import {
  BUTTON_VARIANT_TYPES,
  ButtonStateSelector,
} from "./ButtonStateSelector";
import type { ButtonVariant } from "./ButtonStateSelector";
import { Corners } from "./Corners";
import { Sizing } from "./Sizing";
import { Text } from "./Text";

export const generateFormItemName = (
  buttonVariant: ButtonVariant,
  name: string,
) => {
  const nameParts = name.split(".");
  return ["styles", buttonVariant, ...nameParts].join(".");
};

export const StylesEditor = () => {
  const [selectedButtonVariant, setSelectedButtonVariant] =
    useState<ButtonVariant>(BUTTON_VARIANT_TYPES.default);
  const isPropertiesPanelV2 = useIsPropertiesPanelRevampEnabled();

  return (
    <div
      className={classNames({
        "flex flex-col divide-y": isPropertiesPanelV2,
      })}
    >
      <div
        className={classNames({
          "flex flex-col divide-y": isPropertiesPanelV2,
        })}
      >
        <EditorCollapsable
          title={t("builder_ui.prop_type.styles.type")}
          defaultOpen
        >
          <div className="px-6 pb-5 pt-2">
            <ButtonTypePicker />
          </div>
        </EditorCollapsable>

        <Sizing />

        <EditorCollapsable
          title={t("builder_ui.prop_type.styles.padding")}
          defaultOpen
        >
          <div className="px-6 pb-5">
            <BoxModelInput
              type="padding"
              name="styles.padding"
              label={t("builder_ui.prop_type.styles.padding")}
            />
          </div>
        </EditorCollapsable>

        <EditorCollapsable
          title={t("builder_ui.prop_type.styles.margin")}
          defaultOpen
        >
          <div className="px-6 pb-5">
            <BoxModelInput
              type="margin"
              name="styles.margin"
              label={t("builder_ui.prop_type.styles.margin")}
            />
          </div>
        </EditorCollapsable>
      </div>

      <div
        key={selectedButtonVariant}
        className={classNames({
          "flex flex-col divide-y": isPropertiesPanelV2,
        })}
      >
        <ButtonStateSelector
          selectedButtonVariant={selectedButtonVariant}
          setSelectedButtonVariant={setSelectedButtonVariant}
        />
        <Background selectedButtonVariant={selectedButtonVariant} />
        <Borders selectedButtonVariant={selectedButtonVariant} />
        <Corners selectedButtonVariant={selectedButtonVariant} />
        <Text selectedButtonVariant={selectedButtonVariant} />
      </div>
    </div>
  );
};
